import Enum from "./Enum";

export default Enum.create( {
	LOGGING_IN: "LOGGING_IN", // about to be logged in
	LOGIN: "LOGIN", // definitely logged in
	LOGIN_ERROR: "LOGIN_ERROR",
	LOGGING_OUT: "LOGGING_OUT", // about to be logged out
	LOGOUT: "LOGOUT", // definitely logged out
	SIGNUP: "SIGNUP",
	SIGNUP_ERROR: "SIGNUP_ERROR",
} );
